import { render } from "./StartModelPicker.vue?vue&type=template&id=165f33d4&scoped=true"
import script from "./StartModelPicker.vue?vue&type=script&lang=js"
export * from "./StartModelPicker.vue?vue&type=script&lang=js"

import "./StartModelPicker.vue?vue&type=style&index=0&id=165f33d4&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165f33d4"]])

export default __exports__